import { reDistrictConstants } from './constants'

const initialState =
{
	isSending  : false,
	list       : []
}

export default function (state = initialState, action){
	switch (action.type){
		case reDistrictConstants.GetList.REQUEST:
		case reDistrictConstants.getListActualByRegion.REQUEST:
			return {
				...state,
				isSending : true
			}
		case reDistrictConstants.GetList.FAILURE:
		case reDistrictConstants.getListActualByRegion.FAILURE:
			return {
				...state,
				isSending : false,
				error     : action.payload
			}
		case reDistrictConstants.GetList.SUCCESS:
		case reDistrictConstants.getListActualByRegion.SUCCESS:
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case reDistrictConstants.CLEAR:
			return {
				...state,
				isSending  : false,
				list       : []
			}
		default:
			return state
	}
}